import { render } from "./eb-tab.vue?vue&type=template&id=004bb967"
import script from "./eb-tab.vue?vue&type=script&lang=ts"
export * from "./eb-tab.vue?vue&type=script&lang=ts"
script.render = render

export default script